import { gsap } from 'gsap'
import { ExpoScaleEase } from "gsap/EasePack"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { setupTimelineNavigation, scrollTimelineNavigation } from './elements/timeline-navigation'
import { breakpoint } from './utilities/breakpoint-setup'
import { runTimelinePreloader } from './elements/timeline-preloader'
import { setupTimeline, getTimelineTopPosition} from './utilities/timeline-setup'
import LocomotiveScroll from 'locomotive-scroll'

gsap.registerPlugin(ExpoScaleEase);

  setupTimelineNavigation()

  let scroll = new LocomotiveScroll({
    el: document.querySelector('.smooth-scroll'),
    smooth: true,
    smoothMobile: true,
    lerp: 0.05
  });

  scroll.on("scroll", ScrollTrigger.update);

  ScrollTrigger.scrollerProxy(".smooth-scroll", {
    scrollTop(value) {
      return arguments.length ? scroll.scrollTo(value, 0, 0) : scroll.scroll.instance.scroll.y;
    },
    getBoundingClientRect() {
      return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
    },
    pinType: document.querySelector(".smooth-scroll").style.transform ? "transform" : "fixed"
  });

  let screenHeight = $(window).height()
  let timeline_scroll_coefficient = 1
  let navScrolling = true


  //let timeline = gsap.timeline({'smoothChildTiming': true, ease: 'none'})
  let timelinePreload = gsap.timeline({'smoothChildTiming': true, ease: 'none'})
      timelinePreload.fromTo('#timeline-preloader', { opacity: 1 }, { opacity: 1, duration: 1000})



  let preloaderScroll = ScrollTrigger.create({
    animation: timelinePreload,
    trigger: '#timeline-preloader',
    scroller: '.smooth-scroll',
    scrub: true,
    pin: true,
    start: "top top",
    end: '+=5000',
    onEnter: runPreloader,
    onEnterParams: [this],
  })


  let timelineYears = setupTimeline()


  const myST = ScrollTrigger.create({
    animation: timelineYears.timeline,
    trigger: "#timeline-els",
    scroller: '.smooth-scroll',
    scrub: true,
    pin: true,
    start: "top top",
    end: "+="+(timelineYears.timeHeight),
    onUpdate: self => {
      scrollTimelineNavigation(navScrolling)
    },
    //markers: true
  });


  if(breakpoint('screen') < breakpoint('lg')) {
    stopScroll()
  }



  $('body').on('click', '.years-menu-el', function (e){
    e.preventDefault()
    scrollToTimelinePosition($(this).attr('data-year-scroll'))
  })

  $('body').on('click', '.mobile-go-to-timeline', function (e){

    e.preventDefault()

    $(this).fadeOut()
    $('header').fadeOut()

    scrollToTimelinePosition(25)

  })

  $('body').on('click', '.header-go-to-timeline', function (e){
    e.preventDefault()
    $('.mobile-go-to-timeline').fadeOut()

    //todo fix to function
    let burger = $('.burger')
    if (burger.hasClass('active')){
      $('.js-close-text').css('display', 'none')
      $('.js-open-text').fadeIn(200)
    } else {
      $('.js-open-text').css('display', 'none')
      $('.js-close-text').fadeIn(200)
    }
    burger.toggleClass('active')

    scrollToTimelinePosition(25)
  })

  $('body').on('click', '.js-home-page', function (e){

    e.preventDefault()

    navScrolling = false
    scroll.scrollTo(0, 0, 2000)

    setTimeout(function (){
      navScrolling = true
    }, 2000)
  })


  function startScroll() {
    scroll.start()
  }

  function stopScroll() {
    scroll.stop()
  }

  function runPreloader()
  {
    if($('#timeline-preloader').length) {

      $('.scroll-animation-container').fadeOut()
      stopScroll()
      runTimelinePreloader()
    }

  }

  function killPreloader() {

    preloaderScroll.disable()
    $('#timeline-preloader').remove()
    ScrollTrigger.update()
    ScrollTrigger.refresh()
    scrollToTimelineStart()
    $('.scroll-animation-container').fadeIn()
    $('header').fadeIn()
    startScroll()
    $('.mobile-swipe-animation').removeClass('d-none')
    //$('.not-active-element').removeClass('not-active-element')
  }

  function scrollToTimelinePosition(position)
  {
    let scrollHeight = $('.timeline-container-screen-view').closest('.pin-spacer').outerHeight()
    let last_position = getTimelineTopPosition() //check with screen top height
    let scrollPositionCoef = (scrollHeight + 100) / last_position
    //console.log(scrollPositionCoef)
    //console.log(parseInt(position))
    //navScrolling = false
    let scrollTo = (parseInt(position) * scrollPositionCoef) + screenHeight + 100
    scroll.scrollTo(scrollTo, 0, 2000)

    setTimeout(function (){
      navScrolling = true
      scroll.start()
    }, 2000)
  }

  function scrollToTimelineStart()
  {
    //scrollToTimelinePosition(0)
  }


$(window).on('load', function (){
  if(window.location.hash && window.location.hash === '#celojums-vesture') {
    scrollToTimelinePosition(15)
  }
})


ScrollTrigger.addEventListener("refresh", () => scroll.update());
ScrollTrigger.refresh(true);


export { scrollToTimelineStart, startScroll, killPreloader, scrollToTimelinePosition }

